export default __webpack_public_path__ + "static/aero-0927078030c7aab64f06f87cefd85267.mp4";